import './loader.css';

const Loader = () => {
    return (
        <div className="lds-dual-ring">
        </div>
    )
}

export default Loader;